import {
    deleteFilesProviderLoading,
    deleteFilesProviderRequest,
    deleteFilesProviderSuccess,
    deleteFilesProviderReject,
    deleteFilesProviderReset
} from "../../actions/filesProvider/delete";

export const deleteFilesProvider = (formData) => async (dispatch, getState) => {
    dispatch(deleteFilesProviderLoading());
    try {
        const { data } = await deleteFilesProviderRequest(formData, getState);
        dispatch(deleteFilesProviderSuccess(data))
    } catch (error) {
        dispatch(deleteFilesProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFilesProviderReset()) }, 3000);
    }
    return Promise.resolve();
};